import React, { useEffect, useState } from 'react'
import { PaymentLists } from '../components'
import { useRequest } from '../hooks/useRequest'

export default function PaymentSubcription() {
    const { handleFetch } = useRequest()
    const [loading, setLoading] = useState(false)
    const [paymentList, setPaymentList] = useState([])

    const fetchPayments = async () => {
        setLoading(true)
        try {
            const { data, isSuccess } = await handleFetch('v1/subscriptions/payment/?audience=seller&skip=0&limit=10')

            if (isSuccess) {
                setPaymentList(data)
            }
        } catch (err) {
            console.error(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchPayments()
    }, [])

    return (
        <div>
            <PaymentLists paymentList={paymentList} loading={loading} />
        </div>
    )
}
